import { baseRoutes, authRoutes } from '@/router' 
import store from '../index'
import { filterRouterFun,treeFlat } from '@/utils'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = baseRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }) {
    return new Promise(resolve => {
      let newRouter = []
      if(store.getters.permissions) {
        // 前端接口扁平化,只获取页面/按钮
        let frontTree = treeFlat(authRoutes, 'front')
        let backTree = treeFlat(store.getters.permissions, 'back')
        let newFront = []
        frontTree.forEach(item => {
          newFront = newFront.concat(item)
        });
        newRouter = filterRouterFun(newFront, backTree)
      }
      commit('SET_ROUTES', baseRoutes)
      resolve(baseRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
